export enum TypeSadpath {
  TEXT,
  LENGTH,
}
